import { useQuery } from '@tanstack/react-query';
import { iamApi } from '@/api/iam.api';
import { useAuthStore } from '@/store/auth.store';
import type { AccountProfile } from '@/types/iam.types';

/**
 * 获取当前登录账号/用户的 Valhalla profile（account / user / domain）。
 * 供顶导头像下拉展示账号摘要使用，字段缺失时由调用方隐藏对应展示。
 */
export function useAccountProfile() {
  const token = useAuthStore((s) => s.token);
  return useQuery<AccountProfile>({
    queryKey: ['account-profile', token],
    queryFn: () => iamApi.getAccountProfile(token as string),
    enabled: !!token,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
